exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports
exports.i(require("-!../../../../../node_modules/css-loader/index.js??ref--4-1!../../../../../node_modules/postcss-loader/index.js??postcss!assets/icofont/icofont.min.css"), "");

// module
exports.push([module.id, "/* @import \"~assets/bootstrap/bootstrap.min.css\"; */", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /home/arsalan/Desktop/Dev Stack/Otacon (npm start)/src/app/_components/forgetPassword/resetpassword/resetpassword.component.css
// module id = ../../../../../src/app/_components/forgetPassword/resetpassword/resetpassword.component.css
// module chunks = main